import Header from "@/atomic/atoms/Header";
import { PropsView } from "./Models";
import Loading from "@/atomic/atoms/Loading";
import Modal from "@/atomic/atoms/Modal";
import LoggedMenu from "@/atomic/atoms/LoggedMenu";
import Filter from "@/atomic/organisms/Filters/DebitFilter";
import OrgPayment from "@/atomic/organisms/orgPayment";

const getItemData = (item: any) => {
  return {
    plate: item.plate?.replace(
      /^([A-Za-z]{3})(\d[A-Za-z]?\d{2,3})$/,
      "$1-$2",
    ) || "",
    date: item.date,
    status: item.nmPraca || item.status || "Passagem paga",
    price: `R$ ${item.price}`,
    nmConcessionaria: item.nmConcessionaria
  };
};

export default function HomeView({
  goToVehicles,
  items,
  isLoading,
  isShowingMenu,
  toggleMenu,
  plate,
  isVisibleRecharge,
  setIsVisibleRecharge,
  goToRecharge,
  hasVehicles,
  goToBuy,
  debts,
  cart,
  onChangeDebts,
  activeTab,
  onTabChange,
  goToNewCard,
}: PropsView) {

  return (
    <div className="min-h-screen flex flex-col w-full">
      <Header
        title="Débitos"
        rightButton={
          !isShowingMenu ? (
            <button onClick={toggleMenu} className="flex flex-row items-center">
              <img
                src={"/icon-profile.png"}
                width={20}
                height={20}
                alt="Icone de perfil"
                className="mr-2"
              />
              Perfil
            </button>
          ) : undefined
        }
      />
      <div className="absolute top-16 flex w-full justify-center h-[calc(259px)]">
        <img
          src={"/faixa_topo_3k.jpg"}
          alt="iStock"
          className="absolute object-cover object-[25%_35%] brightness-50 h-[calc(209px)] w-full max-w-[calc(900px)] "
        />
      </div>
      <main className="flex-1 z-10 p-2 w-full flex justify-center h-full text-black h-form mt-3">
        <article className="h-full flex flex-col w-[calc(480px)]">
          <div className="w-full mt-[calc(105px)] mb-[calc(120px)] pb-[calc(120px)]">
            <div className="flex items-center mt-2">
              <img
                src={"/icon-car.png"}
                width={24}
                height={24}
                alt="icon car"
              />
              <p className="ml-1 text-white">Seus veículos:</p>
            </div>
            <div className="flex flex-col gap-3">
              {Array.isArray(plate) ? (
                <div className="flex justify-between gap-3">
                  <div className="flex p-3 mt-1 bg-white rounded-xl border border-[#E6E6E6] items-center w-full h-[calc(81px)]">
                    <p className="text-lg font-bold">
                      {plate.length > 0 ? (
                        plate.length > 1
                          ? `${String(plate.length).padStart(2, '0')} placas selecionadas`
                          : plate[0]?.replace(
                            /^([A-Za-z]{3})(\d[A-Za-z]?\d{2,3})$/,
                            "$1-$2",
                          )
                      ) : "Nenhuma placa cadastrada"}
                    </p>
                  </div>
                  <button
                    className="flex p-3 mt-1 bg-white rounded-xl justify-center items-center w-1/5 border border-[#E6E6E6] h-[calc(81px)]"
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      if (hasVehicles) {
                        goToVehicles(plate);
                      } else {
                        goToBuy();
                      }
                    }}
                  >
                    <img
                      src={hasVehicles ? "/icon-change.png" : "icon-plus.png"}
                      width={18}
                      height={18}
                      alt="Trocar de veículo"
                    />
                  </button>
                </div>
              ) : (
                <div className="flex justify-between gap-3">
                  <div className="flex p-3 mt-1 bg-white rounded-xl border border-[#E6E6E6] items-center w-full h-[calc(81px)]">
                    <p className="text-lg uppercase font-bold">
                      {plate ? plate.replace(
                        /^([A-Za-z]{3})(\d[A-Za-z]?\d{2,3})$/,
                        "$1-$2",
                      ) : "Nenhuma placa"}
                    </p>
                  </div>
                  <button
                    className="flex p-3 mt-1 bg-white rounded-xl justify-center items-center w-1/5 border border-[#E6E6E6] h-[calc(81px)]"
                    type="button"
                    onClick={(e) => {
                      e.preventDefault();
                      if (hasVehicles) {
                        goToVehicles(plate);
                      } else {
                        goToBuy();
                      }
                    }}
                  >
                    <img
                      src={hasVehicles ? "/icon-change.png" : "icon-plus.png"}
                      width={18}
                      height={18}
                      alt="Trocar de veículo"
                    />
                  </button>
                </div>
              )}
            </div>

            <h2 className="text-base text-black mt-4">Débitos</h2>
            <div className="w-full h-px bg-slate-300 mt-4 mb-3" />
            <Filter onTabChange={onTabChange} isLoading={isLoading} activeTab={activeTab} />

            {activeTab === "pendentes" && (
              <>
                {debts && debts.length > 0 && (
                  <div className="mb-4 mt-7">
                    <div className="flex items-center w-full">
                      <input
                        type="checkbox"
                        name="all"
                        className="w-6 h-6 accent-black"
                        onChange={onChangeDebts}
                        checked={debts?.length === cart?.length}
                      />
                      <p className="text-sm ml-6">
                        {"Selecionar "}
                        {debts?.length} passage
                        {debts?.length !== 1 ? "ns" : "m"} em aberto
                      </p>
                    </div>
                    <div className="w-full h-px bg-slate-300 mt-2 mb-2" />
                  </div>
                )}

                {Array.isArray(plate) && plate.length > 0 && debts && debts.length > 0 && (
                  plate.map((currentPlate, plateIndex) => {
                    const plateDebts = debts.filter(debt => debt.plate === currentPlate);

                    return plateDebts.length > 0 ? (
                      <div key={plateIndex} className="mb-4">
                        <div className="flex w-full justify-between items-center py-3 rounded-lg">
                          <p className="text-base uppercase font-bold">
                            {currentPlate.replace(/^([A-Za-z]{3})(\d[A-Za-z]?\d{2,3})$/, "$1-$2")}
                          </p>
                        </div>
                        <div className="w-full h-px bg-slate-300 mt-2 mb-2" />
                        {plateDebts.map((item, index) => (
                          <div key={`${currentPlate}-${index}`}>
                            <div className="flex items-center w-full mt-2">
                              <input
                                type="checkbox"
                                name={item.id}
                                className="w-6 h-6 accent-black"
                                onChange={onChangeDebts}
                                checked={
                                  cart?.some(
                                    (selectable) => selectable.name === item.id && selectable.checked
                                  ) ?? false
                                }
                              />
                              <div className="ml-6 w-full">
                                <div className="flex w-full justify-end">
                                  {item?.daysLeft > 0 && item.hasDate && (
                                    <p className="bg-black text-white text-sm p-1 rounded-lg">
                                      Vencido há {item?.daysLeft} dia(s)
                                    </p>
                                  )}
                                </div>
                                <div className="flex w-full justify-between ">
                                  <p className="text-sm">{item?.fmtDataPassagem || item?.date}</p>
                                  {item?.originalPrice !== item?.price && (
                                    <p className="text-sm line-through">
                                      R$ {item?.originalPrice}
                                    </p>
                                  )}
                                </div>
                                <div className="flex w-full justify-between">
                                  <p className="text-base">
                                    {item?.original?.nmConcessionaria}
                                  </p>
                                </div>
                                <div className="flex justify-between">
                                  <p className="font-bold text-base max-w-72">
                                    {item?.original?.nmPraca}
                                  </p>
                                  <p className="font-bold text-base flex-shrink-0">R$ {item?.price}</p>
                                </div>
                              </div>
                            </div>
                            <div className="w-full h-px bg-slate-300 mt-2 mb-2" />
                          </div>
                        ))}
                      </div>
                    ) : null;
                  })
                )}
                
                {!Array.isArray(plate) && debts?.map((item, index) => (
                  <div key={index}>
                    <div className="flex items-center w-full">
                      <input
                        type="checkbox"
                        name={item.id}
                        className="w-6 h-6 accent-black"
                        onChange={onChangeDebts}
                        checked={
                          cart?.some(
                            (selectable) => selectable.name === item.id && selectable.checked
                          ) ?? false
                        }
                      />
                      <div className="ml-6 w-full">
                        <div className="flex w-full justify-between">
                          <p className="text-base uppercase">{plate}</p>
                          {item?.daysLeft > 0 && item.hasDate && (
                            <p className="bg-black text-white text-sm p-1 rounded-lg">
                              Vencido há {item?.daysLeft} dia(s)
                            </p>
                          )}
                        </div>
                        <div className="flex w-full justify-between">
                          {item.hasDate && <p className="text-sm">{item.fmtDataPassagem || item.date}</p>}
                          {item?.originalPrice !== item?.price && (
                            <p className="text-sm line-through">
                              R$ {item?.originalPrice}
                            </p>
                          )}
                        </div>
                        <div className="flex w-full justify-between">
                          <p className="text-base">
                            {item?.original?.nmConcessionaria}
                          </p>
                        </div>
                        <div className="flex w-full justify-between items-center gap-2">
                          <p className="font-bold text-base flex-1">
                            {item?.original?.nmPraca}
                          </p>
                          <p className="font-bold text-base flex-shrink-0">R$ {item?.price}</p>
                        </div>
                      </div>
                    </div>
                    <div className="w-full h-px bg-slate-300 mt-2 mb-2" />
                  </div>
                ))}

                {!isLoading && (!debts || debts.length === 0) && (
                  <div className="w-full flex justify-center items-center flex-col mt-10">
                    <img
                      src={"/icon-car-front-close.png"}
                      width={48}
                      height={48}
                      alt="Ícone carro"
                      className="mt-6"
                    />
                    <h2 className="mt-1 text-sm text-center px-8">
                      Nenhuma passagem em aberto encontrada. <br />
                      As passagens podem levar até 48 horas para ficarem disponíveis
                      no sistema para pagamento.
                    </h2>
                    <div className="border-1 border border-gray-400 w-full p-4 rounded-lg flex items-center mb-5 mt-20">
                      <img
                        src={"/icon-square.png"}
                        width={40}
                        height={40}
                        alt="Informação"
                        className="h-[calc(40px)] w-[calc(40px)]"
                      />
                      <p className="ml-2 text-gray-600 text-sm">
                        Se o veículo possui TAG a cobrança é automática. Verifique se a TAG está ativa e se os débitos aparecem na fatura de sua operadora. Caso contrário, consulte possíveis pendências aqui.
                      </p>
                    </div>
                  </div>
                )}
              </>
            )}

            {activeTab === "pagos" && (
              <>
                {!isLoading && items && items.length > 0 && (
                  <div className="w-full mt-8">
                    <h2 className="text-base text-black mb-4">Histórico de Passagens Pagas</h2>
                    {items?.map((item, index) => {
                      const itemData = getItemData(item);
                      return (
                        <div key={index}>
                          <div className="flex items-center w-full justify-between">
                            <div className="flex flex-col">
                              <p className="text-base uppercase">{itemData.plate}</p>
                              <p className="text-sm">{itemData.date}</p>
                              <p className="text-base">{itemData.nmConcessionaria}</p>
                              <p className="font-bold text-base">
                                {itemData.status}
                              </p>
                            </div>
                            <div className="flex">
                              <p className="font-bold text-base flex-shrink-0">{itemData.price}</p>
                            </div>
                          </div>
                          <div className="w-full h-px bg-slate-300 mt-2 mb-2" />
                        </div>
                      );
                    })}
                  </div>
                )}

                {!isLoading && (!items || items.length === 0) && (
                  <div className="w-full flex justify-center items-center flex-col mt-10">
                    <img
                      src={"/icon-car-front-close.png"}
                      width={48}
                      height={48}
                      alt="Ícone carro"
                      className="mt-6"
                    />
                    <h2 className="mt-1 text-sm text-center">
                      Nenhuma passagem paga encontrada.
                    </h2>
                  </div>
                )}
              </>
            )}

            {isLoading && <Loading />}
          </div>
        </article>
        {activeTab === "pendentes" && debts && debts.length > 0 && (
          <OrgPayment onClick={goToRecharge} />
        )}
      </main>
      <LoggedMenu isShowingMenu={isShowingMenu} toggleMenu={toggleMenu} />
      {isVisibleRecharge && (
        <Modal
          title="Tudo pronto!"
          messageElement={
            <p className="text-sm text-center text-gray-600">
              Quer cadastrar seu{" "}
              <span className="font-bold">
                Cartão
                <br />
                de Crédito
              </span>{" "}
              e facilitar seus pagamentos.
            </p>
          }
          actionMessage="Cadastrar"
          action={goToNewCard}
          actionSecondMessage="Agora não"
          actionSecond={() => setIsVisibleRecharge(false)}
        />
      )}
    </div>
  );
}
